module.exports = __webpack_public_path__ + "static/media/icon-summary-inactive.72ffa4bc.svg";